define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/xml",
	"csi/xml/Query",
	"Specification/BOM/BOMSectionMixin",
	"./PartMaterialBOMSectionMixin"
], function(declare,AggregateFrom,xml,Query,BOMSectionMixin,PartMaterialBOMSectionMixin) {

	return declare([AggregateFrom, BOMSectionMixin, PartMaterialBOMSectionMixin], {

		_getFixedFilters: function() {
			// filter on ApplicablePlacementProductTypes of the BOMSectionDefinition if we are grouped
			var q = new Query().Attr("InAssortment", xml.OP_EQUALS, true, "Child:ProductType/Child:ProductionConfig")
			.Attr("Active", xml.OP_EQUALS, true);

			if (!this.actionWidget || (this.actionWidget.pluginName !== "ToolbarNewActions")) {
				// this only applies to the row action not table action
				var qr = this.widget.getQueryResultByDomNode(this.refNode);
				this.applyBomSectionQuery(qr.parentResult.groupValue, q, this.m_cache);
			}

			let groupProductType = this.widget.getActionElementGroupProductType(this);
			if (groupProductType) {
				q.RefAttr("ProductType", xml.OP_EQUALS, groupProductType);
			}

			return q.getElements();
		}
	});
});
